import type { CardId } from '../../../model/types';
import type { CARD_SUMMARY_SET_TYPE, CardSummarySetAction } from './types';

export const CARD_SUMMARY_SET: CARD_SUMMARY_SET_TYPE = 'state.actions.summary.CARD_SUMMARY_SET';

export const cardSummarySet = (cardId: CardId, summary: string | null): CardSummarySetAction => ({
	type: CARD_SUMMARY_SET,
	payload: {
		cardId,
		summary,
	},
});

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports, @atlassian/eng-health/no-barrel-files/disallow-reexports
export type { CARD_SUMMARY_SET_TYPE, CardSummarySetAction };
